import { get, post, del, patch } from "src/services/api";

const fetchDataProcessors = async ({ accountId }) => {
  const endpoint = `/accounts/${accountId}/data-processors`;
  return await get({ endpoint });
};

const fetchDataProcessor = async ({ accountId, dataProcessorId }) => {
  const endpoint = `/accounts/${accountId}/data-processors/${dataProcessorId}`;
  return await get({ endpoint });
};

const createDataProcessor = async ({ accountId, data }) => {
  const endpoint = `/accounts/${accountId}/data-processors`;
  return await post({ endpoint, data });
};

const updateDataProcessor = async ({ accountId, dataProcessorId, data }) => {
  const endpoint = `/accounts/${accountId}/data-processors/${dataProcessorId}`;
  return await patch({ endpoint, data });
};

const deleteDataProcessor = async ({ accountId, dataProcessorId }) => {
  const endpoint = `/accounts/${accountId}/data-processors/${dataProcessorId}`;
  return await del({ endpoint });
};

const fetchSkillFields = async ({ accountId, dataProcessorId, campaignId }) => {
  const endpoint = `/accounts/${accountId}/data-processors/${dataProcessorId}/campaigns/${campaignId}/fields`;
  return await get({ endpoint });
};

export default {
  fetchDataProcessors,
  fetchDataProcessor,
  createDataProcessor,
  updateDataProcessor,
  deleteDataProcessor,
  fetchSkillFields
};
